"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const db_mapper_1 = __importDefault(require("../base/db-mapper"));
const permissions_model_1 = __importDefault(require("./permissions.model"));
class PermissionsMapper extends db_mapper_1.default {
    async loadCompanyPermissions(companyID) {
        //Load company permissions and default incase they don't exist
        const companyPermissions = await super.loadBatch([companyID, 'default']);
        return companyPermissions.find(cp => cp.ID === companyID) || companyPermissions[0];
    }
}
exports.default = db_mapper_1.default.registerModel('permissions', permissions_model_1.default, PermissionsMapper);
